module.exports = __webpack_public_path__ + "img/setup_step1.90bb456a.svg";